export const clientPermissionsConst = {
  view: {
    value: "view_client",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu klientów!",
  },
  add: {
    value: "add_client",
    errorMsg: "Użytkownik nie ma uprawnień do dodania klientów!",
  },
  update: {
    value: "change_client",
    errorMsg: "Użytkownik nie ma uprawnień do edycji klientów!",
  },
  delete: {
    value: "delete_client",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania klientów!",
  },
};
